import React, { useState, useEffect, useRef } from 'react';
import { Button, Card, Col, Form, Input, message, Modal, Popconfirm, Row, Select, SelectProps, Space, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import HTTPService from '../../../utils/makerequest';
import { Toast } from 'primereact/toast';
import { ICompany } from '../../../interfaces/ICompany';
import { IAuthentication, UserRole } from '../../../interfaces/authentication';
import { StateLoader } from '../../../redux/StateLoader';
import { CloseOutlined, DeleteOutlined, PlusOutlined, SaveOutlined } from '@ant-design/icons';
import { IDepartmentData } from '../../../interfaces/IDepartmentData';
import { ISupplierData } from '../../../interfaces/ISupplierData';
import { IBrandData } from '../../../interfaces/IBrandData';
import { ITypeData } from '../../../interfaces/ITypeData';
import { IInventoryStatusData } from '../../../interfaces/IInventoryStatusData';
import { ICampusData } from '../../../interfaces/ICampusData';
import { ILocationData } from '../../../interfaces/ILocationData';
import { ICategoryData } from '../../../interfaces/ICategoryData';
import AltisDataGrid, { IAltisDataGridColumns } from '../../../AltisComponent/AltisDataGrid';
import AddInventoryStatus from '../InventoryStatus/AddInventoryStatus';
import AddCampus from '../CampusManagement/AddCampus';
import AddLocation from '../LocationManagement/AddLocation';
import AddCategory from '../CategoryManagement/AddCategory';
import AddType from '../TypeManagement/AddType';
import AddDepartment from '../DepartmentManagement/AddDepartment';
import AddSupplier from '../SupplierManagement/AddSupplier';
import AddBrand from '../BrandManagement/AddBrand';
import { IItemData } from '../../../interfaces/IItemData';
import Dropdown from '../../../AltisComponent/Dropdown';

const AddInventoryQuick: React.FunctionComponent = () => {
    const { t } = useTranslation();
    const [companyData, setCompanyData] = useState<ICompany[]>([]);
    const [departmentData, setDepartmentData] = useState<IDepartmentData[]>([]);
    const [supplierData, setSupplierData] = useState<ISupplierData[]>([]);
    const [brandData, setBrandData] = useState<IBrandData[]>([]);
    const [typeData, setTypeData] = useState<ITypeData[]>([]);
    const [campusData, setCampusData] = useState<ICampusData[]>([]);
    const [categoryData, setCategoryData] = useState<ICategoryData[]>([]);
    const [locationData, setLocationData] = useState<ILocationData[]>([]);
    const [inventoryStatusData, setInventoryStatusData] = useState<IInventoryStatusData[]>([]);
    const [userData, setUserData] = useState([]);
    const [filteredUserData, setFilteredUserData] = useState([]);
    const [itemData, setItemData] = useState<IItemData>({});
    const [selectedImages, setSelectedImages] = useState<File[]>([]);
    const [selectedCompany, setSelectedCompany] = useState<number | undefined>(undefined);
    const [selectedCampus, setSelectedCampus] = useState<number | undefined>(undefined);
    const [selectedCategory, setSelectedCategory] = useState<number | undefined>(undefined);
    const [selectedType, setSelectedType] = useState<number | undefined>(undefined);
    const [selectedResponsible, setSelectedResponsible] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalVisibleCampus, setIsModalVisibleCampus] = useState(false);
    const [isModalVisibleLocation, setIsModalVisibleLocation] = useState(false);
    const [isModalVisibleCategory, setIsModalVisibleCategory] = useState(false);
    const [isModalVisibleType, setIsModalVisibleType] = useState(false);
    const [isModalVisibleDepartment, setIsModalVisibleDepartment] = useState(false);
    const [isModalVisibleSupplier, setIsModalVisibleSupplier] = useState(false);
    const [isModalVisibleBrand, setIsModalVisibleBrand] = useState(false);

    const toast = useRef<any>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const loader = new StateLoader();
    const user: IAuthentication = loader.loadAuthState();

    useEffect(() => {
        fetchCompanies();
    }, []);

    useEffect(() => {
        if (selectedCompany || user?.companyId) {
            fetchDepartment(selectedCompany || user.companyId);
            fetchCampusByCompany(selectedCompany || user.companyId);
            fetchCategoryByCompany(selectedCompany || user.companyId);
            fetchBrandByCompany(selectedCompany || user.companyId);
            fetchSupplier(selectedCompany || user.companyId);
            fetchInventoryStatus(selectedCompany || user.companyId);
            fetchUser(selectedCompany || user.companyId);
        } else {
            setDepartmentData([]);
            setSupplierData([]);
            setBrandData([]);
            setUserData([]);
        }
    }, [selectedCompany]);


    const columns: IAltisDataGridColumns[] = [
        {
            title: t('Responsible Name'),
            key: 'displayName',
            placeHolder: t('Responsible Name'),
            inputType: "input",
        },
        {
            title: t('Operations'),
            key: 'operations',
            placeHolder: t('Operations'),
            inputType: "operations",

            render: (order, record) => (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '8px' }}>
                    <Popconfirm
                            title={<div>
                                {t('responsibleToast')} <br />
                            </div>}
                            onConfirm={() => DeleteResponsible(record.userId)}
                            okText={t("yes")}
                            cancelText={t("no")}
                        >
                            <Button
                                size='small'
                                icon={<DeleteOutlined />}
                                onClick={(e) => { e.stopPropagation(); }}
                            >{t('delete')}</Button>
                        </Popconfirm>
                </div>
            ),
        },
    ];

    const DeleteResponsible = (id: number) => {
        const newObj = { ...itemData };

        const responsible = userData.find(responsible => responsible.userId === id);

        if (Array.isArray(newObj.responsibleList)) {
            newObj.responsibleList = newObj.responsibleList.filter(row => row !== id);
        }

        setItemData(newObj);

        setFilteredUserData(prevData => prevData.filter(item => item.userId !== id));

        if (responsible) {
            toast.current?.show({
                severity: 'success',
                summary: t('successful'),
                detail: `"${responsible.displayName}" ${t('responsibleDeleteToast')}`,
                life: 3000
            });
        } else {
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('responsibleNotFound'),
                life: 3000
            });
        }
    };


    // const handleAddResponsible = () => {
    //     const selectedUserData = userData.find(app => app.userId === selectedResponsible);

    //     if (selectedUserData) {
    //         setFilteredUserData(prevData => [
    //             ...prevData,
    //             { userId: selectedUserData.userId, displayName: selectedUserData.displayName }
    //         ]);
    //     }
    // };

    const savedNewCampus = (campus: ICampusData) => {
        setCampusData(prevLocationData => [...prevLocationData, campus]);
        formRef.current.setFieldValue("campusId", campus.campusId);
        setLocationData([]);
        setSelectedCampus(campus.campusId)
        formRef.current.setFieldValue("locationId", null);
    }

    const savedNewLocation = (location: ILocationData) => {
        formRef.current.setFieldValue("locationId", location.locationId);
        setLocationData(prevLocationData => [...prevLocationData, location]);
    }

    const savedNewCategory = (category: ICategoryData) => {
        formRef.current.setFieldValue("categoryId", category.categoryId);
        setCategoryData(prevCategoryData => [...prevCategoryData, category]);
        setSelectedCategory(category.categoryId)
        formRef.current.setFieldValue("typeId", null);
        setTypeData([]);
    }

    const savedNewType = (type: ITypeData) => {
        formRef.current.setFieldValue("typeId", type.typeId);
        setSelectedCategory(type.categoryId)
        setTypeData(prevTypeData => [...prevTypeData, type]);
    }

    const savedNewDepartment = (department: IDepartmentData) => {
        formRef.current.setFieldValue("departmentId", department.departmentId);
        setDepartmentData(prevDepartmentData => [...prevDepartmentData, department]);
    }

    const savedNewBrand = (brand: IBrandData) => {
        formRef.current.setFieldValue("brandId", brand.brandId);
        setBrandData(prevBrandData => [...prevBrandData, brand]);
    }

    const savedNewSupplier = (supplier: ISupplierData) => {
        formRef.current.setFieldValue("supplierId", supplier.supplierId);
        setSupplierData(prevSupplierData => [...prevSupplierData, supplier]);
    }

    const savedNewStatus = (status: IInventoryStatusData) => {
        formRef.current.setFieldValue("inventoryStatusId", status.inventoryStatusId);
        setSupplierData(prevStatusData => [...prevStatusData, status]);
    }

    const handleAddResponsible = () => {
        const selectedUserData = userData.find(user => user.userId === selectedResponsible);

        if (selectedUserData && !filteredUserData.some(user => user.userId === selectedUserData.userId)) {
            setFilteredUserData(prevData => [
                ...prevData,
                { userId: selectedUserData.userId, displayName: selectedUserData.displayName }
            ]);
        }
    };

    const fetchCompanies = async () => {
        try {
            const result = await HTTPService.GETCompanyNames();
            setCompanyData(result);
        } catch (error) {
            console.error(error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_message'),
                life: 3000
            });
        }
    };

    const fetchCategoryByCompany = async (companyId: number) => {
        try {
            const companyID = companyId ?? user.companyId;
            const result = await HTTPService.GETCategoryByCompany(companyID);
            setCategoryData(result);
        } catch (error) {
            console.error(error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_message'),
                life: 3000
            });
        }
    };

    const fetchBrandByCompany = async (companyId: number) => {
        try {
            const result = await HTTPService.GETBrandNames(companyId);
            setBrandData(result);
        } catch (error) {
            console.error(error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_message'),
                life: 3000
            });
        }
    };

    const fetchDepartment = async (companyId: number) => {
        try {
            const result = await HTTPService.GETDepartmentNames(companyId);
            setDepartmentData(result);
        } catch (error) {
            console.error(error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_message'),
                life: 3000
            });
        }
    };

    const fetchSupplier = async (companyId: number) => {
        try {
            const result = await HTTPService.GETSupplierNames(companyId);
            setSupplierData(result);
        } catch (error) {
            console.error(error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_message'),
                life: 3000
            });
        }
    };

    const fetchType = async (categoryId: string) => {
        try {
            const result = await HTTPService.GETTypeNamesByCategory(categoryId.toString());
            setTypeData(result);
            formRef.current.setFieldValue("typeId", null);
        } catch (error) {
            console.error(error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_message'),
                life: 3000
            });
        }
    };

    const fetchInventoryStatus = async (companyId: number) => {
        try {
            const result = await HTTPService.GETInventoryStatusNames(companyId);
            setInventoryStatusData(result);
        } catch (error) {
            console.error(error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_message'),
                life: 3000
            });
        }
    };

    const fetchUser = async (companyId: number) => {
        try {
            const result = await HTTPService.GETUserNames(companyId);
            setUserData(result);
        } catch (error) {
            console.error(error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_message'),
                life: 3000
            });
        }
    };

    const fetchCampusByCompany = async (companyId: number) => {
        try {
            const result = await HTTPService.GETCampusByCompany(companyId);
            setCampusData(result);
        } catch (error) {
            console.error(error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_message'),
                life: 3000
            });
        }
    };

    const fetchAllLocationNameByCampus = async (campusId: string) => {
        try {
            const result = await HTTPService.GETAllLocationNameByCampus(campusId);
            setLocationData(result);
        } catch (error) {
            console.error(error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_message'),
                life: 3000
            });
        }
    };

    const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const fileList = event.target.files;
        if (fileList) {
            const files = Array.from(fileList) as File[];
            setSelectedImages(prevImages => [...prevImages, ...files]);
        }
    };

    const handleImageRemove = (index: number) => {
        setSelectedImages(prevImages => prevImages.filter((_, i) => i !== index));
    };

    const handleSelectChange = (value) => {
        setSelectedResponsible(value);

        toast.current?.show({
            severity: 'warn',
            summary: t('Warning'),
            detail: t('pressPlusIcon'),
            life: 3000
        });
    };

    const handleCategoryChange = (
        value: string | number | (() => void) | ((category: ICategoryData) => void),
        option?: any
    ) => {
        if (typeof value === 'string' || typeof value === 'number') {
            const categoryId = typeof value === 'number' ? value : Number(value);
            fetchType(categoryId.toString());
            setSelectedCategory(categoryId);
        }
    };

    // const handleTypeChange = (companyId: number) => {
    //     setSelectedType(companyId);
    // };


    const handleFormSubmit = async (values: any) => {
        const formData = new FormData();

        selectedImages.forEach((image, index) => {
            formData.append('files', image);
        });

        filteredUserData.forEach((userData, index) => {
            formData.append('responsibleUserList', userData.userId)
        })


        const referanceNo = values.referanceNo;
        const serialNo = values.serialNo;
        const epc = values.epc;
        const customBarcode = values.customBarcode;
        const nfc = values.nfc;

        formData.append('inventoryTBL.barcode', "barcode"); // zorunlu alan oldugu için gönderilmektedir. readonly bir veridir.
        formData.append('inventoryTBL.companyId', user?.role === UserRole.AltisAdmin ? values.companyId : user?.companyId);
        formData.append('inventoryTBL.departmentId', values.departmentId?.toString());
        formData.append('inventoryTBL.supplierId', values.supplierId?.toString());
        formData.append('inventoryTBL.brandId', values.brandId?.toString());
        formData.append('inventoryTBL.inventoryStatusId', values.inventoryStatusId?.toString());
        formData.append('inventoryTBL.categoryId', values.categoryId?.toString());
        formData.append('inventoryTBL.campusId', values.campusId?.toString());
        formData.append('inventoryTBL.typeId', values.typeId.toString());
        formData.append('inventoryTBL.actualLocationId', values.locationId?.toString());
        formData.append('inventoryTBL.locationName', values.locationName);
        if (referanceNo) {
            formData.append('inventoryTBL.referanceNo', values.referanceNo);
        }
        formData.append('inventoryTBL.inventoryName', values.inventoryName);
        if (serialNo) {
            formData.append('inventoryTBL.serialNo', values.serialNo);
        }
        if (values.debtUserId) {
            formData.append('inventoryTBL.debtUserId', values.debtUserId);
        }

        if (nfc) {
            formData.append('inventoryTBL.nfc', values.nfc);
        }

        if (epc) {
            formData.append('inventoryTBL.epc', values.epc);
        }

        if (customBarcode) {
            formData.append('inventoryTBL.customBarcode', values.customBarcode);
        }


        try {

            const response = await HTTPService.POST(`/Inventory/registerInventory`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.status === 200) {
                toast.current?.show({
                    severity: 'success',
                    summary: t('successful'),
                    detail: t('register_success'),
                    life: 3000
                });
                formRef.current.setFieldsValue({ inventoryName: null });
                formRef.current.setFieldsValue({ serialNo: null });
                formRef.current.setFieldsValue({ referanceNo: null });
                formRef.current.setFieldsValue({ customBarcode: null });
                formRef.current.setFieldsValue({ epc: null });
                formRef.current.setFieldsValue({ nfc: null });
                formRef.current.setFieldValue("responsibleList", null); //!!error
                formRef.current.setFieldValue("debtUserId", null);
                setFilteredUserData([])
            } else if (response.status === 450) {
                toast.current?.show({
                    severity: 'error',
                    summary: t('errors'),
                    detail: t(response.data),
                    life: 3000
                });
            } else if (response.status === 400) {
                toast.current?.show({
                    severity: 'error',
                    summary: t('errors'),
                    detail: t(response.data),
                    life: 3000
                });
            }
            else {
                toast.current?.show({
                    severity: 'error',
                    summary: t('errors'),
                    detail: t('registration_failed'),
                    life: 3000
                });
            }
        } catch (error) {
            console.error(t('registration_failed'));
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('registration_failed'),
                life: 3000
            });
        }
    };

    const filterOption: SelectProps<any>['filterOption'] = (input, option) => {
        return (option?.children as unknown as string).toLowerCase().includes(input.toLowerCase());
    };
    const handleGridChange = () => {
        fetchUser(selectedCompany || user.companyId);
    };

    const showModal = () => {
        setIsModalVisible(true);
    };

    const showModalCampus = () => {
        setIsModalVisibleCampus(true);
    };

    const showModalLocation = () => {
        setIsModalVisibleLocation(true);
    };

    const showModalCategory = () => {
        setIsModalVisibleCategory(true);
    };

    const showModalDepartment = () => {
        setIsModalVisibleDepartment(true);
    };

    const showModalType = () => {
        setIsModalVisibleType(true);
    };

    const showModalSupplier = () => {
        setIsModalVisibleSupplier(true);
    };


    const showModalBrand = () => {
        setIsModalVisibleBrand(true);
    };

    const handleCancelCampus = () => {
        setIsModalVisibleCampus(false);
        fetchCampusByCompany(selectedCompany || user.companyId)
    };

    const handleCancelCategory = () => {
        setIsModalVisibleCategory(false);
        fetchCategoryByCompany(selectedCompany || user.companyId);
    };

    const handleCancelSupplier = () => {
        setIsModalVisibleSupplier(false);
        fetchSupplier(selectedCompany || user.companyId);
    };

    const handleCancelBrand = () => {
        setIsModalVisibleBrand(false);
        fetchBrandByCompany(selectedCompany || user.companyId);
    };

    const handleCancelDepartment = () => {
        setIsModalVisibleDepartment(false);
        fetchDepartment(selectedCompany || user.companyId)
    };

    const handleCancelStatus = () => {
        setIsModalVisible(false);
        fetchInventoryStatus(selectedCompany || user.companyId);
    };

    const selectedChangeCompany = (value) => {
        setSelectedCompany(value);
        formRef.current.setFieldValue("campusId", null);
        formRef.current.setFieldValue("locationId", null);
        fetchCampusByCompany(value);
        formRef.current.setFieldValue("statusId", null);
        fetchInventoryStatus(value);
        formRef.current.setFieldValue("categoryId", null);
        fetchCategoryByCompany(value);
        formRef.current.setFieldValue("supplierId", null);
        fetchSupplier(value);
        formRef.current.setFieldValue("brandId", null);
        fetchBrandByCompany(value);
        formRef.current.setFieldValue("departmentId", null);
        fetchDepartment(value);
        formRef.current.setFieldValue("typeId", null);
        //fetchType(value);
        formRef.current.setFieldValue("responsibleList", null);
        formRef.current.setFieldValue("debtUserId", null);
        setItemData(prevData => ({ ...prevData, companyId: value }));
        setFilteredUserData([]);
    }

    const formRef = useRef(null);
    return (
        <Card style={{ padding: '50px' }}>
            <Toast ref={toast} />
            <h3>{t('add_new_item_speed')}</h3>
            <Form ref={formRef} layout='vertical' onFinish={handleFormSubmit}>
                {/* <Form.Item
                    name='images'
                    label={t('upload_image')}
                >
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        multiple
                    />
                    {selectedImages.length > 0 && (
                        <div style={{ marginTop: '20px', marginBottom: '20px', display: 'flex', flexWrap: 'wrap' }}>
                            {selectedImages.map((image, index) => (
                                <div key={index} style={{ position: 'relative', marginRight: '10px', marginBottom: '10px' }}>
                                    <img
                                        src={URL.createObjectURL(image)}
                                        alt={`preview ${index}`}
                                        style={{ maxWidth: '150px', maxHeight: '150px', borderRadius: '4px' }}
                                    />
                                    <Button
                                        icon={<DeleteOutlined />}
                                        size="small"
                                        style={{ position: 'absolute', bottom: '0', right: '0', margin: '5px' }}
                                        onClick={() => handleImageRemove(index)}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                    <Button
                        icon={<UploadOutlined />}
                        onClick={() => fileInputRef.current?.click()}
                        style={{ marginBottom: '20px' }}
                    >
                        {t('Select Images')}
                    </Button>
                </Form.Item> */}

                {user?.role === UserRole.AltisAdmin && (
                    <Form.Item
                        name='companyId'
                        label={t('Company Name')}
                        rules={[{ required: true, message: t('select_company') }]}
                    >
                        <Select
                            showSearch
                            placeholder={t('Company Name')}
                            //onChange={handleCompanyChange}
                            onChange={selectedChangeCompany}
                            filterOption={filterOption}
                        >
                            {companyData.map(company => (
                                <Select.Option key={company.companyId} value={company.companyId}>
                                    {company.companyName}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                )}

                <Form.Item
                    name='campusId'
                    label={
                        <Tooltip title={t('select_campus_description')}>
                            {t('campus')}
                        </Tooltip>
                    }
                    rules={[{ required: true, message: t('select_campus') }]}
                >
                    <Dropdown
                        tooltip={t('select_campus_description')}
                        rules={[{ required: true, message: t('select_campus') }]}
                        placeholder={t('campus')}
                        dataSource={campusData}
                        labelKey="campusName"
                        valueKey="campusId"
                        includeEmptyOption={false}
                        style={{ width: 'calc(100% - 50px)' }}
                        dropdownStyle={{ minWidth: 200 }}
                        onChange={(value) => {
                            if (typeof value === 'string' || typeof value === 'number') {
                                fetchAllLocationNameByCampus(String(value));
                                setSelectedCampus(Number(value));
                                formRef.current.setFieldValue('locationId', undefined);
                            }
                        }}
                    />
                </Form.Item>

                <Form.Item
                    style={{ marginBottom: -5, marginTop: -8 }}
                >
                    <Row justify="end">
                        <Col>
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={showModalCampus}
                                style={{ marginLeft: 8, marginTop: -100 }}
                            />
                        </Col>
                    </Row>
                </Form.Item>


                <Modal
                    visible={isModalVisibleCampus}
                    footer={null}
                    onCancel={handleCancelCampus}
                    width={790}
                    style={{ top: 20 }}
                    bodyStyle={{ padding: '0px', display: 'flex', flexDirection: 'column', height: '35vh' }}
                >
                    <div style={{ flex: 1 }}>
                        <AddCampus cancelModal={handleCancelCampus} savedObj={savedNewCampus}
                            companyId={selectedCompany} campusId={itemData.locationTBL?.campusTBL?.campusId} campusName={itemData.locationTBL?.campusTBL?.campusName}
                        />
                    </div>
                </Modal>

                <Form.Item
                    name='locationId'
                    label={
                        <Tooltip title={t('select_location_description')}>
                            {t('location')}
                        </Tooltip>
                    }
                    rules={[{ required: true, message: t('select_location') }]}
                >

                    <Dropdown
                        label={t('location')}
                        tooltip={t('select_location_description')}
                        rules={[{ required: true, message: t('select_location') }]}
                        placeholder={t('location')}
                        dataSource={locationData}
                        labelKey="locationName"
                        valueKey="locationId"
                        onChange={() => setIsModalVisibleLocation(false)}
                        style={{ width: 'calc(100% - 50px)' }}
                        dropdownStyle={{ minWidth: 300 }}
                    />
                </Form.Item>

                <Form.Item
                    style={{ marginBottom: 0, marginTop: -8 }}
                >
                    <Row justify="end">
                        <Col>
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={showModalLocation}
                                style={{ marginLeft: 8, marginTop: -100 }}
                            />
                        </Col>
                    </Row>
                </Form.Item>
                <Modal
                    visible={isModalVisibleLocation}
                    footer={null}
                    onCancel={() => setIsModalVisibleLocation(false)}
                    width={790}
                    bodyStyle={{ padding: '0px', display: 'flex', flexDirection: 'column', height: '35vh' }}
                >
                    <div style={{ flex: 1 }}>
                        <AddLocation savedObj={savedNewLocation} cancelModal={() => setIsModalVisibleLocation(false)} companyId={selectedCompany} campusId={selectedCampus} campusTBL={itemData.locationTBL?.campusTBL} locationName={itemData.locationTBL?.campusTBL.campusName} />
                    </div>
                </Modal>

                <Form.Item
                    name='departmentId'
                    label={
                        <Tooltip title={t('select_department_description')}>
                            {t('department_name')}
                        </Tooltip>
                    }
                    rules={[{ required: true, message: t('department_name') }]}
                >
                    <Dropdown
                        name="departmentId"
                        label={t('department_name')}
                        tooltip={t('select_department_description')}
                        rules={[{ required: true, message: t('department_name') }]}
                        placeholder={t('department_name')}
                        dataSource={departmentData}
                        labelKey="departmentName"
                        valueKey="departmentId"
                        style={{ width: 'calc(100% - 50px)' }}
                        dropdownStyle={{ minWidth: 300 }}
                    />
                </Form.Item>

                <Form.Item
                    style={{ marginBottom: 0, marginTop: -8 }}
                >
                    <Row justify="end">
                        <Col>
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={showModalDepartment}
                                style={{ marginLeft: 8, marginTop: -100 }}  // Responsive margin
                            />
                        </Col>
                    </Row>
                </Form.Item>

                <Modal
                    visible={isModalVisibleDepartment}
                    footer={null}
                    onCancel={handleCancelDepartment}
                    width={790}
                    bodyStyle={{ padding: '0px', display: 'flex', flexDirection: 'column', height: '35vh' }}
                >
                    <div style={{ flex: 1 }}>
                        <AddDepartment cancelModal={handleCancelDepartment} savedObj={savedNewDepartment}
                            companyId={selectedCompany} departmentName={itemData.typeName} departmentId={itemData.departmentId}
                        />
                    </div>
                </Modal>


                <Form.Item
                    name='categoryId'
                    label={
                        <Tooltip title={t('select_category_description')}>
                            {t('item_group')}
                        </Tooltip>
                    }
                    rules={[{ required: true, message: t('item_group') }]}
                >
                    <Dropdown
                        label={t('item_group')}
                        tooltip={t('select_category_description')}
                        rules={[{ required: true, message: t('item_group') }]}
                        placeholder={t('item_group')}
                        dataSource={categoryData}
                        labelKey="categoryName"
                        valueKey="categoryId"
                        style={{ width: 'calc(100% - 50px)' }}
                        dropdownStyle={{ minWidth: 180 }}
                        onChange={handleCategoryChange}
                    />
                </Form.Item>

                <Form.Item
                    style={{ marginBottom: 0, marginTop: -8 }}
                >
                    <Row justify="end">
                        <Col>
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={showModalCategory}
                                style={{ marginLeft: 8, marginTop: -100 }}  // Responsive margin
                            />
                        </Col>
                    </Row>
                </Form.Item>


                <Modal
                    visible={isModalVisibleCategory}
                    footer={null}
                    onCancel={handleCancelCategory}
                    width={790}
                    bodyStyle={{ padding: '0px', display: 'flex', flexDirection: 'column', height: '35vh' }}
                >
                    <div style={{ flex: 1 }}>
                        <AddCategory cancelModal={handleCancelCategory} savedObj={savedNewCategory}
                            companyId={selectedCompany} categoryName={itemData.categoryName}
                        />
                    </div>
                </Modal>

                <Form.Item
                    name='typeId'
                    label={
                        <Tooltip title={t('select_type_description')}>
                            {t('item_type')}
                        </Tooltip>
                    }
                    rules={[{ required: true, message: t('Please select type') }]}
                >
                    <Dropdown
                        name="typeId"
                        label={t('item_type')}
                        tooltip={t('select_type_description')}
                        rules={[{ required: true, message: t('Please select type') }]}
                        placeholder={t('item_type')}
                        dataSource={typeData}
                        labelKey="typeName"
                        valueKey="typeId"
                        includeEmptyOption={false}
                        style={{ width: 'calc(100% - 50px)' }}
                        dropdownStyle={{ minWidth: 300 }}
                        value={selectedType}
                        onChange={(value) => {
                            if (typeof value === 'string' || typeof value === 'number') {
                                setSelectedType(Number(value));
                            }
                        }}
                    />
                </Form.Item>

                <Form.Item
                    style={{ marginBottom: 0, marginTop: -8 }}
                >
                    <Row justify="end">
                        <Col>
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={showModalType}
                                style={{ marginLeft: 8, marginTop: -100 }}  // Responsive margin
                            />
                        </Col>
                    </Row>
                </Form.Item>


                <Modal
                    visible={isModalVisibleType}
                    footer={null}
                    onCancel={() => setIsModalVisibleType(false)}
                    width={790}
                    bodyStyle={{ padding: '0px', display: 'flex', flexDirection: 'column', height: '35vh' }}
                >
                    <div style={{ flex: 1 }}>
                        <AddType cancelModal={() => setIsModalVisibleType(false)} savedObj={savedNewType}
                            companyId={selectedCompany} typeName={itemData.typeName} categoryId={selectedCategory}
                        />
                    </div>
                </Modal>



                <Form.Item
                    name='supplierId'
                    label={
                        <Tooltip title={t('select_supplier_description')}>
                            {t('supplier_name')}
                        </Tooltip>
                    }
                    rules={[{ required: true, message: t('supplier_name') }]}
                >
                    <Dropdown
                        name="supplierId"
                        label={t('supplier_name')}
                        tooltip={t('select_supplier_description')}
                        rules={[{ required: true, message: t('supplier_name') }]}
                        placeholder={t('supplier_name')}
                        dataSource={supplierData}
                        labelKey="supplierName"
                        valueKey="supplierId"
                        style={{ width: 'calc(100% - 50px)' }}
                        dropdownStyle={{ minWidth: 180 }}
                    />
                    {/* <Col>
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    style={{ marginLeft: '8px' }}
                    onClick={showModalSupplier}
                />
                </Col> */}
                </Form.Item>

                <Form.Item
                    style={{ marginBottom: 0, marginTop: -8 }}
                >
                    <Row justify="end">
                        <Col>
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={showModalSupplier}
                                style={{ marginLeft: 8, marginTop: -100 }}
                            />
                        </Col>
                    </Row>
                </Form.Item>


                <Modal
                    visible={isModalVisibleSupplier}
                    footer={null}
                    onCancel={handleCancelSupplier}
                    width={790}
                    bodyStyle={{ padding: '0px', display: 'flex', flexDirection: 'column', height: '35vh' }}
                >
                    <div style={{ flex: 1 }}>
                        <AddSupplier cancelModal={handleCancelSupplier} savedObj={savedNewSupplier}
                            companyId={itemData.companyId} supplierName={itemData.supplierName}
                        />
                    </div>
                </Modal>

                <Form.Item
                    name="inventoryStatusId"
                    label={
                        <Tooltip title={t('select_status_description')}>
                            {t('status')}
                        </Tooltip>
                    }
                    rules={[{ required: true, message: t('pleaseStatus') }]}
                >
                    <Dropdown
                        name="inventoryStatusId"
                        label={t('status')}
                        tooltip={t('select_status_description')}
                        rules={[{ required: true, message: t('pleaseStatus') }]}
                        placeholder={t('status')}
                        dataSource={inventoryStatusData}
                        labelKey="inventoryStatusName"
                        valueKey="inventoryStatusId"
                        style={{ width: 'calc(100% - 50px)' }}
                        dropdownStyle={{ minWidth: 180 }}
                    />
                    {/* <Col>
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            style={{ marginLeft: '8px' }}
                            onClick={showModal}
                        />
                    </Col> */}
                </Form.Item>

                <Form.Item
                    style={{ marginBottom: 0, marginTop: -8 }}
                >
                    <Row justify="end">
                        <Col>
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={showModal}
                                style={{ marginLeft: 8, marginTop: -100 }}  // Responsive margin
                            />
                        </Col>
                    </Row>
                </Form.Item>

                <Modal
                    visible={isModalVisible}
                    footer={null}
                    onCancel={handleCancelStatus}
                    width={790}
                    bodyStyle={{ padding: '0px', display: 'flex', flexDirection: 'column', height: '35vh' }}
                >
                    <div style={{ flex: 1 }}>
                        <AddInventoryStatus savedObj={savedNewStatus}
                            companyId={selectedCompany} inventoryStatusName={itemData.inventoryStatusName} cancelModal={handleCancelStatus}
                        />
                    </div>
                </Modal>

                <Form.Item
                    name='brandId'
                    label={
                        <Tooltip title={t('select_brand_description')}>
                            {t('brand')}
                        </Tooltip>
                    }
                    rules={[{ required: true, message: t('brand') }]}
                >
                    <Dropdown
                        name="brandId"
                        label={t('brand')}
                        tooltip={t('select_brand_description')}
                        rules={[{ required: true, message: t('brand') }]}
                        placeholder={t('brand')}
                        dataSource={brandData}
                        labelKey="brandName"
                        valueKey="brandId"
                        style={{ width: 'calc(100% - 50px)' }}
                        dropdownStyle={{ minWidth: 180 }}
                    />
                    {/* <Col>
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    style={{ marginLeft: '8px' }}
                    onClick={showModalBrand}
                />
                </Col> */}
                </Form.Item>

                <Form.Item
                    style={{ marginBottom: 0, marginTop: -8 }}
                >
                    <Row justify="end">
                        <Col>
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={showModalBrand}
                                style={{ marginLeft: 8, marginTop: -100 }}  // Responsive margin
                            />
                        </Col>
                    </Row>
                </Form.Item>


                <Modal
                    visible={isModalVisibleBrand}
                    footer={null}
                    onCancel={handleCancelBrand}
                    width={790}
                    bodyStyle={{ padding: '0px', display: 'flex', flexDirection: 'column', height: '35vh' }}
                >
                    <div style={{ flex: 1 }}>
                        <AddBrand cancelModal={handleCancelBrand} savedObj={savedNewBrand}
                            companyId={selectedCompany} brandName={itemData.brandName}
                        />
                    </div>
                </Modal>
                <Form.Item
                    name='inventoryName'
                    label={t('item_name')}
                    rules={[{ required: true, message: t('input_item_name'), whitespace: true }]}
                >
                    <Input
                        placeholder={t('item_name')} style={{ borderRadius: '0' }}
                    />
                </Form.Item>


                <Form.Item
                    name='debtUserId'
                    label={
                        <Tooltip title={t('select_debit_description')}>
                            {t('Debit Name')}
                        </Tooltip>
                    }
                    rules={[{ required: false, message: t('debit_name') }]}
                >
                    <Dropdown
                        name="debtUserId"
                        label={t('Debit Name')}
                        tooltip={t('select_debit_description')}
                        rules={[{ required: false, message: t('debit_name') }]}
                        placeholder={t('Debit Name')}
                        dataSource={userData}
                        labelKey="displayName"
                        valueKey="userId"
                    />
                </Form.Item>

                <Form.Item
                    name='responsibleList'
                    label={
                        <Tooltip title={t('select_responsible_description')}>
                            {t('responsibleName')}
                        </Tooltip>
                    }
                    rules={[{ required: false, message: t('selectResponsible') }]}
                    style={{ marginBottom: 0 }}
                >
                    <Row gutter={8} align="middle">
                        <Col flex="auto">
                            <Select
                                showSearch
                                placeholder={t('selectResponsible')}
                                onChange={handleSelectChange}
                                filterOption={filterOption}
                            >
                                {userData?.map((responsible) => (
                                    <Select.Option key={responsible.userId} value={responsible.userId}>
                                        {responsible.displayName}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Col>
                        <Col>
                            <Button style={{ borderRadius: '5px' }} type="primary" onClick={handleAddResponsible}>
                                {t('addResponsible')}
                            </Button>
                        </Col>
                    </Row>
                    <br></br>
                    <AltisDataGrid
                        data={filteredUserData}
                        total={filteredUserData.length}
                        columns={columns}
                        onChange={handleGridChange}
                    />
                    <br></br>
                </Form.Item>


                <Form.Item
                    name="customBarcode"
                    label={t("barcode")}
                    rules={[
                        { message: t("input_barcode"), whitespace: true },
                        {
                            validator: (_, value) => {
                                if (!value) return Promise.resolve();

                                if (/^\d+$/.test(value)) {
                                    if (value.length > 32) {
                                        return Promise.reject(new Error(t("barcode_max_length", { length: 32 })));
                                    }
                                }
                                else if (/^[a-zA-Z]+$/.test(value)) {
                                    if (value.length > 16) {
                                        return Promise.reject(new Error(t("barcode_max_length", { length: 16 })));
                                    }
                                }
                                else if (/^[a-zA-Z0-9]+$/.test(value)) {
                                    if (value.length > 16) {
                                        return Promise.reject(new Error(t("barcode_max_length_16", { length: 16 })));
                                    }
                                } else {
                                    if (value.length > 16) {
                                        return Promise.reject(new Error(t("barcode_max_length_16", { length: 16 })));
                                    }
                                }

                                return Promise.resolve();
                            },
                        },
                    ]}
                >
                    <Input placeholder={t("barcode")} style={{ borderRadius: "0" }} />
                </Form.Item>




                <Form.Item
                    name='nfc'
                    label={t('nfc')}
                    rules={[{ message: t('input_nfc'), whitespace: true },
                    {
                        validator: (_, value) => {
                            if (!value) return Promise.resolve();

                            if (/^\d+$/.test(value)) {
                                if (value.length > 32) {
                                    return Promise.reject(new Error(t("nfc_max_length", { length: 32 })));
                                }
                            }
                            else if (/^[a-zA-Z]+$/.test(value)) {
                                if (value.length > 16) {
                                    return Promise.reject(new Error(t("nfc_max_length", { length: 16 })));
                                }
                            }
                            else if (/^[a-zA-Z0-9]+$/.test(value)) {
                                if (value.length > 16) {
                                    return Promise.reject(new Error(t("nfc_max_length_16", { length: 16 })));
                                }
                            } else {
                                if (value.length > 16) {
                                    return Promise.reject(new Error(t("nfc_max_length_16", { length: 16 })));
                                }
                            }

                            return Promise.resolve();
                        },
                    },
                    ]}

                >
                    <Input
                        placeholder={t('nfc')}
                        style={{ borderRadius: '0' }}
                    />
                </Form.Item>


                <Form.Item
                    name='epc'
                    label={t('epc')}
                    rules={[{ message: t('input_epc'), whitespace: true }]}
                >
                    <Input
                        placeholder={t('epc')}
                        style={{ borderRadius: '0' }}
                    />
                </Form.Item>



                <Form.Item
                    name='serialNo'
                    label={t('serialNo')}
                    rules={[{ message: t('input_serialNo'), whitespace: true }]}
                >
                    <Input
                        placeholder={t('serialNo')}
                    />
                </Form.Item>

                <Form.Item
                    name='referanceNo'
                    label={t('Referance No')}
                    rules={[{ message: t('input_destination'), whitespace: true }]}
                >
                    <Input
                        placeholder={t('Referance No')}
                    />
                </Form.Item>

                <Form.Item>
                    <Row gutter={[8, 8]} justify="end" align="middle">
                        <Col xs={12} sm={12} md={4}>
                            <Button
                                block
                                href="/admin/inventory-management"
                                type="primary"
                                style={{
                                    height: 64,
                                    backgroundColor: 'transparent',
                                    color: '#1890ff',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '0 10px',
                                    border: 'none',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(1.05)';
                                    e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                                    e.currentTarget.style.color = '#40a9ff';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                    e.currentTarget.style.boxShadow = 'none';
                                    e.currentTarget.style.color = '#1890ff';
                                }}
                            >
                                <CloseOutlined style={{ fontSize: 20 }} />
                                <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                                    {t('cancel')}
                                </span>
                            </Button>
                        </Col>
                        <Col xs={12} sm={4}>
                            <Button
                                block
                                //href="/admin/inventory-management"
                                type="primary"
                                htmlType='submit'
                                style={{
                                    height: 64,
                                    backgroundColor: 'transparent',
                                    color: '#1890ff',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '0 10px',
                                    border: 'none',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(1.05)';
                                    e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                                    e.currentTarget.style.color = '#40a9ff';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                    e.currentTarget.style.boxShadow = 'none';
                                    e.currentTarget.style.color = '#1890ff';
                                }}
                            >
                                <SaveOutlined style={{ fontSize: 20 }} />
                                <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                                    {t('save')}
                                </span>
                            </Button>
                        </Col>
                    </Row>
                </Form.Item>
            </Form>
        </Card>
    );
};

export default AddInventoryQuick;
